<template>
  <div data-dev="builder-page">
    <div v-if="content && customComponents" :class="[{ 'container-parent': !applyFullPage }]">
      <div class="container-child">
        <div ref="box_ani" class="container-sub-child"
          :class="[{ '!font-gotham box-ani': slug == 'healthy-coffee-23' }]">
          <Content model="page" :content="content" :api-key="BUILDER_API_KEY" :customComponents="customComponents" />
        </div>
      </div>
    </div>
    <ContextMenu />
  </div>
</template>
<script setup>
import { Content, fetchOneEntry } from '@builder.io/sdk-vue';

useHead({
  layout: "default",
  title: "Healthy Coffee 2023",
  description: "Lifeboost Coffee is the healthiest coffee on the planet. Our coffee is 100% certified organic, single origin, shade grown, fairly traded, and small batch roasted in the USA.",
  link: [
    {
      rel: 'preload',
      as: 'font',
      crossorigin: '',
      type: 'font/woff2',
      href: '/assets/fonts/Gotham-Book.woff2'
    },
    {
      rel: 'preload',
      as: 'font',
      crossorigin: '',
      type: 'font/ttf',
      href: '/assets/fonts/GothamBold.ttf'
    },
    {
      rel: 'preload',
      as: 'font',
      crossorigin: '',
      type: 'font/woff2',
      href: '/assets/fonts/wigrumweb-medium.woff2'
    },
    {
      rel: 'preload',
      as: 'font',
      crossorigin: '',
      type: 'font/woff2',
      href: '/assets/fonts/Roboto-Italic.woff2'
    },
    {
      rel: 'preload',
      as: 'font',
      crossorigin: '',
      type: 'font/woff2',
      href: '/assets/fonts/Roboto-Regular.woff2'
    }
  ],
});

const config = useRuntimeConfig();
const BUILDER_API_KEY = config.public.builderIO.apiKey;

const box_ani = ref(null);
const applyFullPage = ref(false)

const route = useRoute();
const slug = route.params.slug

const customComponents = useBuilderComponents()

const { data: content } = await useAsyncData('builderData', () =>
  fetchOneEntry({
    model: 'page',
    apiKey: BUILDER_API_KEY,
    userAttributes: {
      urlPath: `/${slug}`
    },
  }));

if (content.value === null) {
  useBugsnag().notify(new Error('404 Triggered: Page Not Found', slug));
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
    fatal: true
  })
}

const fullPage = content?.value?.data?.fullWidthPage;

 if (fullPage && fullPage === 'on') {
      applyFullPage.value = true
 }

if (content && content?.value?.data) {
  useSeoMeta({
    title: () => content.value.data.title,
    description: () => content.value.data.description,
    image: () => content.value.data.metaImage
  })

  onMounted(async () => {

    box_ani?.value?.classList?.add('shadow');



    const builderData = await fetchOneEntry({
      model: 'page',
      apiKey: BUILDER_API_KEY,
      userAttributes: {
        urlPath: `/${slug}`,
      },
    })


    const GTMTrack = () => {
      const data = builderData
      const eventData = {
        experiment_name: data.name,
        variation_name: data.testVariationName,
        variation_id: data.testVariationId,
      }

      window.dataLayer = window.dataLayer || [];

      window.dataLayer?.push(
        {
          event: 'builderio_experiment',
          ...eventData
        }
      )
    }

    if (builderData?.hasOwnProperty('testVariationId') && builderData.meta.winningTest === null) {
      GTMTrack();
    }
  });
}

</script>

<style lang="postcss" scoped>
.font-gotham {
  font-family: 'Gotham', sans-serif;
}
#fader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  pointer-events: none;
  background: #fff;
  animation-duration: .3s;
  animation-timing-function: ease-in-out;
  opacity: 1
}

@keyframes fade-out {
  from {
    opacity: 1
  }

  to {
    opacity: 0
  }
}

@keyframes fade-in {
  from {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

#fader.fade-out {
  animation-name: fade-out;
  opacity: 0
}

#fader.fade-in {
  animation-name: fade-in;
  opacity: 1
}

.box-ani {
  box-shadow: 0;
  transition: box-shadow 1s;
}

.box-ani.shadow {
  box-shadow: 0 0 27px rgba(11, 11, 12, .39);
}

.container-parent {
  @apply bg-bgGrayBody md-max:pb-12;
}

.container-parent .container-child {
  @apply w-full px-8 pb-0 m-auto max-w-7xl sm-max:px-5 lg:pb-16;
}

.container-parent .container-sub-child {
  @apply relative w-full max-w-6xl m-auto bg-white text-21;
}
</style>
